import React from 'react';
import { Star, Shield } from 'lucide-react';

interface Testimonial {
  name: string;
  role: string;
  quote: string;
  stars: number;
  tier: string;
}

const testimonials: Testimonial[] = [
  {
    name: 'Sarah K.',
    role: 'Graduate Student',
    quote: 'I went from 200 to 450 WPM in a week. The streak system keeps me coming back every day.',
    stars: 5,
    tier: 'Reader',
  },
  {
    name: 'Marcus T.',
    role: 'Software Engineer',
    quote: "Finally a reading app that doesn't feel like a chore. The achievements make it addictive.",
    stars: 5,
    tier: 'Ultra',
  },
  {
    name: 'Dr. Lisa M.',
    role: 'Research Scientist',
    quote: 'The RSVP approach is backed by real science. I use it to get through papers faster.',
    stars: 5,
    tier: 'Reader',
  },
];

export const UpsellSocialProof: React.FC = () => {
  return (
    <div className="mb-16">
      <h2 className="text-3xl font-bold text-slate-900 dark:text-white text-center mb-8">
        What Readers Are Saying
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {testimonials.map((t, i) => (
          <div key={i} className="testimonial-card">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: t.stars }).map((_, j) => (
                <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" />
              ))}
            </div>
            <p className="text-slate-700 dark:text-slate-300 text-sm leading-relaxed mb-4 italic">
              "{t.quote}"
            </p>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-semibold text-slate-900 dark:text-white text-sm">{t.name}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400">{t.role}</p>
              </div>
              <span className="text-xs font-medium px-2 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400">
                {t.tier}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Trust bar */}
      <div className="flex flex-wrap items-center justify-center gap-6 py-4 px-6 bg-slate-50 dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800">
        <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
          Join 10,000+ readers
        </span>
        <span className="text-slate-300 dark:text-slate-600">|</span>
        <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
          4.9/5 average rating
        </span>
        <span className="text-slate-300 dark:text-slate-600">|</span>
        <span className="text-sm font-medium text-slate-600 dark:text-slate-400 flex items-center gap-1">
          <Shield className="w-4 h-4 text-emerald-500" />
          Secure & verified
        </span>
        <span className="text-slate-300 dark:text-slate-600">|</span>
        <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
          ❤️ Loved by readers
        </span>
      </div>
    </div>
  );
};
